import { Injectable } from "@angular/core";
import { AbstractControl, FormControl, ValidatorFn } from "@angular/forms";

@Injectable({
    providedIn: "root",
})
export class ValidadoresFormularioService {
    public regexSoloNumerosYPunto = "[0-9]+([.][0-9]+)?";
    public regexSoloNumeros = /^\d+$/;
    public regexFormatoHora = "^(2[0-3]|[01]?[0-9]):([0-5][0-9])$";
    constructor() {}

    getDv(rutSinDv: number) {
        var M = 0,
            S = 1;
        for (; rutSinDv; rutSinDv = Math.floor(rutSinDv / 10))
            S = (S + (rutSinDv % 10) * (9 - (M++ % 6))) % 11;
        return S ? (S - 1).toString() : "k";
    }

    validadorRut(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            let rutValor = control.value;

            if (rutValor) {
                if (rutValor.includes("-") && rutValor.slice(-1) !== "-") {
                    let rutArray = rutValor.split("-");
                    let dv = this.getDv(rutArray[0]);

                    if (rutArray[1].toLowerCase() !== dv) {
                        //si hay error se retorna un objeto sino null
                        return {
                            digitoVerificador: {
                                digito: dv,
                            },
                        };
                    }
                    return null;
                }
                return {
                    digitoVerificador: {
                        digito: null,
                    },
                };
            }
            return null;
        };
    }

    requiredFileType(type: string) {
        return function (control: FormControl) {
            const file = control.value;
            if (file) {
                const extension = file.name.split(".")[1].toLowerCase();
                if (type.toLowerCase() !== extension.toLowerCase()) {
                    return {
                        requiredFileType: true,
                    };
                }

                return null;
            }

            return null;
        };
    }
}
